import { parseJWT } from "helpers/index";
import { Cookies } from "lib/cookie-monster";
import { VehicleData, AanbiederSoort } from "components/VDP/VehicleDetailWrapper/types";

// TODO should be removed after  automotive datalayer removal is deployed and tested (Amvd-283)

interface parseBasicDataArgs {
    passedToken: string | "" | undefined;
    cookies: Cookies;
    pageName: string;
    initialUrl: string;
}

export function parseBasicDataToPageData({
    passedToken,
    cookies,
    pageName,
    initialUrl
}: parseBasicDataArgs) {
    const token = !passedToken ? null : parseJWT(passedToken);

    return {
        event: "page_view",
        page_location:
            typeof window !== "undefined"
                ? window.location.pathname + window.location.search
                : initialUrl,
        pageType:
            typeof pageName === "string" ? `gtm-${pageName.toLowerCase()}` : "gtm-pagename-error",
        server: process.env.NODE_ENV === "development" ? "acc" : "prod",
        testVariant: cookies && cookies["N-test"] ? cookies["N-test"] : "at_unknown",
        userId: (token && token.sub) || "undefined",
        userLogin: token && token.aud ? "ingelogd" : "niet ingelogd",
        userLoginType: token && token.aud ? "autotrack" : "niet ingelogd",
        userType: (token && token.aud) || "guest"
    };
}

export function calculateMonthDiff(d1: Date, d2: Date) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}

export function calculateCarAgeInMonths(carFirstOnRoadString: string) {
    return calculateMonthDiff(new Date(carFirstOnRoadString), new Date());
}

interface dataLayerCarObject {
    brand: string;
    carAgeInMonths: string | number;
    carBodyShapeType: string;
    carColorSimple: string;
    carDoors: string | number;
    carEnergyLabel: string;
    carFuel:
        | "AARDGAS"
        | "ALCOHOL"
        | "BENZINE"
        | "DIESEL"
        | "ELEKTRICITEIT"
        | "HYBRIDE_BENZINE"
        | "HYBRIDE_DIESEL"
        | "HYBRIDE"
        | "LPG"
        | "WATERSTOF";
    carImported: string | false;
    carMileage: string | number;
    carModel: string;
    carPriceOriginal: string | number;
    carPublishDate: string;
    carTransmission: "HANDMATIG" | "AUTOMATISCH" | "SEMI_AUTOMATISCH" | "CONTINU_VARIABEL";
    carVersion: string;
    carYearOfBuild: string | number;
    category: string;
    dealerCity: string;
    dealerID: number;
    dealerName: string;
    dealerType: AanbiederSoort;
    id: number;
    name: string;
    price: string | number;
    roadTaxMax: number;
    roadTaxMin: number;
    list?: string;
    position?: number | string;
}
export function createCarObjectFromProductData(
    product: VehicleData,
    origin?: "zoekresultaten",
    index?: number
): dataLayerCarObject {
    const defaultValue = "undefined";

    const brand = product?.autogegevens?.algemeen?.merknaam ?? defaultValue;
    const carAgeInMonths =
        (product?.autogegevens?.geschiedenis?.datumEersteToelatingInternationaal &&
            calculateCarAgeInMonths(
                product.autogegevens?.geschiedenis.datumEersteToelatingInternationaal
            )) ??
        defaultValue;
    const carBodyShapeType = product?.autogegevens?.algemeen?.carrosserievorm ?? defaultValue;
    const carColorSimple = product?.autogegevens?.algemeen?.kleur ?? defaultValue;
    const carDoors = product?.autogegevens?.algemeen?.aantalDeuren ?? defaultValue;
    const carEnergyLabel = product?.autogegevens?.milieu?.energielabel ?? defaultValue;
    const carFuel = product?.autogegevens?.algemeen?.brandstofsoort ?? defaultValue;
    const carImported = (product?.autogegevens?.geschiedenis?.geimporteerd && "true") ?? "false";
    const carMileage = product?.autogegevens?.geschiedenis?.kilometerstand ?? defaultValue;
    const carModel = product?.autogegevens?.algemeen?.modelnaam ?? defaultValue;
    const carPriceOriginal = product?.autogegevens?.geschiedenis?.catalogusprijs ?? defaultValue;
    const carPublishDate = product?.datumGeplaatst ?? defaultValue;
    const carTransmission = product?.autogegevens?.algemeen?.transmissietype ?? defaultValue;
    const carVersion = product?.autogegevens?.algemeen?.uitvoering ?? defaultValue;
    const carYearOfBuild = product?.autogegevens?.geschiedenis?.bouwjaar ?? defaultValue;
    const category = product?.autogegevens?.algemeen?.voertuigsoort ?? defaultValue;
    const dealerCity = product?.aanbieder?.aanbiedergegevens?.plaatsnaam ?? defaultValue;
    const dealerID = product?.aanbieder?.aanbiederId ?? defaultValue;
    const dealerName = product?.aanbieder?.aanbiedergegevens?.naam ?? defaultValue;
    const dealerType = product?.aanbieder?.soort ?? defaultValue;
    const advertentieId = product?.advertentieId ?? defaultValue;
    const advertentieName =
        (product?.autogegevens?.algemeen?.merknaam &&
            product?.autogegevens?.algemeen?.modelnaam &&
            product?.autogegevens?.algemeen?.uitvoering &&
            `${product.autogegevens?.algemeen.merknaam} ${product.autogegevens?.algemeen.modelnaam} ${product.autogegevens?.algemeen.uitvoering}`) ??
        defaultValue;
    const price = product?.prijs?.totaal ?? defaultValue;
    const roadTaxMax =
        product?.autogegevens?.matenEnGewichten?.maximaleWegenbelasting ?? defaultValue;
    const roadTaxMin =
        product?.autogegevens?.matenEnGewichten?.minimaleWegenbelasting ?? defaultValue;
    const list = origin ?? defaultValue;
    const position = index ?? defaultValue;
    /* End get specific values and check for their validity */

    const carObjectToReturn = {
        brand,
        carAgeInMonths,
        carBodyShapeType,
        carColorSimple,
        carDoors,
        carEnergyLabel,
        carFuel,
        carImported,
        carMileage,
        carModel,
        carPriceOriginal,
        carPublishDate,
        carTransmission,
        carVersion,
        carYearOfBuild,
        category,
        dealerCity,
        dealerID,
        dealerName,
        dealerType,
        id: advertentieId,
        name: advertentieName,
        price,
        roadTaxMax,
        roadTaxMin,
        list,
        position
    };
    return carObjectToReturn;
}
